const breakpoints = {
  small: '@media (max-width: 767px)',
}

export default breakpoints
